import { gql } from '@apollo/client'
import { Heading, IconList } from '@farol-ds/react'
import classNames from 'classnames'

import { LockIcon } from '../lock-icon'
import { BenefitsList_OfferLockCardFragment } from './__generated__/benefits-list.graphql'
import styles from './benefits-list.module.scss'

export type BenefitsListProps = {
  offerLockCard: BenefitsList_OfferLockCardFragment
  listContainerClassName?: string
  iconClassName?: string
}

export function BenefitsList({
  offerLockCard,
  listContainerClassName,
  iconClassName,
}: BenefitsListProps) {
  const { benefitsList = [] } = offerLockCard

  const benefitsListClasses = classNames(styles.listContainer, listContainerClassName)

  return (
    <IconList size="md" unstyled className={benefitsListClasses}>
      {benefitsList.map(({ name, isHighlighted, icon }, index) => {
        return (
          <IconList.Item
            key={index}
            className={classNames({ [styles.benefitHighlighted]: isHighlighted })}
            icon={icon ? <LockIcon icon={icon} className={iconClassName} /> : null}
          >
            {isHighlighted ? (
              <Heading size="sm" className={styles.benefitHighlightedTitle}>
                {name}
              </Heading>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: name }} />
            )}
          </IconList.Item>
        )
      })}
    </IconList>
  )
}

BenefitsList.fragments = {
  offerLockCard: gql`
    fragment BenefitsList_offerLockCard on OfferLockCard {
      benefitsList {
        name
        isHighlighted
        icon {
          ...LockIcon_offerLockIcon
        }
      }
    }
    ${LockIcon.fragments.icon}
  `,
}
